import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBvHv-A6MoNJkf5RVSStV5LHsEVeYU3d5E",
  authDomain: "vmsapp-95d7e.firebaseapp.com",
  databaseURL: "https://vmsapp-95d7e.firebaseio.com",
  projectId: "vmsapp-95d7e",
  storageBucket: "vmsapp-95d7e.appspot.com",
  messagingSenderId: "729572340901",
  appId: "1:729572340901:web:38f976e6fa43cfa6d5494c",
  measurementId: "G-TDR0NE54VY"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
export const db = firebaseApp.firestore();
const { TimeStamp, GeoPoint } = firebase.firestore
export { TimeStamp, GeoPoint }
//db.settings({ timestampsInSnapshots: true })

export var storage = firebase.storage();

Vue.config.productionTip = false


new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
